
import { DateTime } from 'luxon';
import { tsXLXS } from 'ts-xlsx-export';
import { IDefecturaExcel} from "../../../../libs/coreapi-dto/service/defectura";

export const ExportExcel = (data: IDefecturaExcel[]) =>{
    tsXLXS().exportAsExcelFile(data).saveAsExcelFile("Defectura " + DateTime.now().toFormat('dd.MM.yyyy hh/mm/ss'));
}